import { z } from 'zod';

export type PaginationMeta = {
    pagination: {
        current_page: number,
        last_page: number,
        per_page: number,
        total: number,
    },
};

export const PaginationMetaSchema = z.object({
    pagination: z.object({
        current_page: z.number(),
        last_page: z.number(),
        per_page: z.number(),
        total: z.number(),
    }),
});
